/* eslint-disable react-hooks/exhaustive-deps */
import "./css/normalize.css"; //CSS reset
import "./css/site.css";

import React from "react";
import { Route, Switch, useLocation, Redirect } from "react-router-dom";
import { TransitionGroup, CSSTransition } from "react-transition-group";

import { PAGE_ROUTES } from "../utils/stateTypes";
import Page404 from "./home/404";
import RememberScroll from "./general/RememberScroll";
import PageTransition from "./general/PageTransition";
import TopNav from "./home/TopNav";
import Footer from "./home/Footer";
import Home from "./home/Home";
import Contact from "./contact/Contact";
import Booking from "./booking/Booking";
import Corporate from "./corporate/Corporate";
import Store from "./store/Store";
import Product from "./store/Product";
import ThankYou from "./store/ThankYou";
import CancelSubscription from "./store/CancelSubscription";
import MealPlanForm from "./store/MeanPlanForm";
import EBook from "./home/eBook";
import Welcome from "./welcome/Welcome";

const App = () => {
  let location = useLocation();

  return (
    <div>
      <RememberScroll />
      <PageTransition />
      <TopNav />
      <TransitionGroup>
        <CSSTransition
          key={location.pathname}
          classNames={"fade"}
          timeout={700}
        >
          <Switch location={location}>
            <Route
              exact
              path={PAGE_ROUTES.HOME}
              component={Home}
            />
            <Route
              exact
              path={PAGE_ROUTES.EBOOK}
              component={EBook}
            />
            <Route
              exact
              path={PAGE_ROUTES.BOOK}
              component={Booking}
            />
            <Route
              exact
              path={PAGE_ROUTES.CONTACT}
              component={Contact}
            />
            <Route
              exact
              path={PAGE_ROUTES.CORPORATE}
              component={Corporate}
            />
            <Route
              exact
              path={PAGE_ROUTES.STORE}
              component={Store}
            />
            <Route
              exact
              path={PAGE_ROUTES.PRODUCT}
              component={Product}
            />
            <Route
              exact
              path={PAGE_ROUTES.THANK_YOU}
              component={ThankYou}
            />
            <Route
              exact
              path={PAGE_ROUTES.CANCEL_SUBSCRIPTION}
              component={CancelSubscription}
            />
            <Route
              exact
              path={PAGE_ROUTES.MEAL_PLAN_FORM}
              component={MealPlanForm}
            />
            <Route
              exact
              path={PAGE_ROUTES.WELCOME}
              component={Welcome}
            />
            {/* Old site redirects */}
            <Redirect
              from={"/product-category/plans"}
              to={PAGE_ROUTES.STORE}
            />
            <Redirect
              from={"/schedule-a-consultation"}
              to={PAGE_ROUTES.BOOK}
            />
            <Redirect
              from={"/get-an-exercise-plan"}
              to={PAGE_ROUTES.STORE}
            />
            <Redirect
              from={"/get-a-meal-plan"}
              to={PAGE_ROUTES.STORE}
            />
            <Route
              component={Page404}
            />
          </Switch>
        </CSSTransition>
      </TransitionGroup>
      <Footer />
    </div>
  );
};

export default App;
